import React from "react";
import { Placeholder, Grid, GridColumn, GridRow } from "semantic-ui-react";
import PlaceholderLine from "semantic-ui-react/dist/es/elements/Placeholder/PlaceholderLine";
import PropTypes from "prop-types";
export default function VmoFormPlaceholder({
    columns = 1,
    rows = 1,
    isContainer = false,
    gridProps = {},
    gridRowProps = {},
    gridColumnProps = {},

}) {
    return (

        <Grid container={isContainer} columns={columns} width="equal" {...gridProps}>
            {
                Array.from({ length: rows }, (_, rowIndex) => {
                    return (
                        <GridRow key={`row-${rowIndex}`} {...gridRowProps} >
                            {
                                Array.from({ length: columns }, (_, columnIndex) => (
                                    <GridColumn key={`cell-${rowIndex}-${columnIndex}`} {...gridColumnProps}>
                                        <Placeholder fluid>
                                            <PlaceholderLine
                                                length={'very short'}
                                            />
                                            <PlaceholderLine
                                            />
                                        </Placeholder>
                                    </GridColumn>
                                ))
                            }
                        </GridRow>
                    )
                })
            }
        </Grid >
    )

}

VmoFormPlaceholder.defaultProps = {
    columns: 1,
    rows: 1,
    isContainer: false,
    gridProps: {},
    gridRowProps: {},
    gridColumnProps: {}

}

VmoFormPlaceholder.propTypes = {
    columns: PropTypes.number,
    rows: PropTypes.number,
    lines: PropTypes.number,
    isContainer: PropTypes.bool,
    gridProps: PropTypes.object,
    gridRowProps: PropTypes.object,
    gridColumnProps: PropTypes.object
};